export interface DefaultCustomerState {
  memos: [];
  memosLoading: boolean;
  absence: [];
  absenceLoading: boolean;
  myCustomers: [];
  myCustomersLoading: boolean;
}

export const defaultCustomerState: DefaultCustomerState = {
  memos: [],
  memosLoading: false,
  absence: [],
  absenceLoading: false,
  myCustomers: [],
  myCustomersLoading: false
};
